import MicroModal from 'micromodal';
import { IFramePlayer } from '../../../libs/gin-tonic/components/player';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-player-modal' })
export class PlayerModalComponent {
	private player: IFramePlayer = undefined;

	constructor(private element: HTMLElement) {
		element.addEventListener('click', () => {
			MicroModal.show(element.getAttribute('data-trigger-for'), {
				onShow: this.openModal.bind(this),
			});
		})
	}

	openModal(modal: Element) {
		const playerElement = modal.querySelector('.js-player') as HTMLElement;
		let src = this.element.getAttribute('data-player-src') || '';
		if (playerElement) {
			src = src.replace('&controls=0', '');
			playerElement.querySelector('iframe')?.setAttribute('src', src)
			this.player = new IFramePlayer(playerElement);
			this.player.play();
		}

		const closeTriggers = Array.from(modal.getElementsByClassName('js-modal-close'));
		closeTriggers.forEach(trigger => trigger.addEventListener('click', this.closeModal.bind(this)));
	}

	closeModal() {
		const modalId = this.element.getAttribute('data-trigger-for');
		this.player?.destroy()
		MicroModal.close(modalId);
	}
}
